import React, { useState } from "react"

import Layout from "./Layout"
import Seo from "./Seo";//TODO - set title below

import 'typeface-roboto'

import Pwa from './Pwa/';
import IDANativeBridge from "./IDANativeBridge";
import { useAllEntities } from "../hooks/all-entities";
import { useAllModules } from "../hooks/all-modules";
import { EntityRepository } from "../repository/EntityRepository";
import { GlobalContext } from "../context/GlobalContext";
import { ModuleRepository } from "../repository/ModuleRepository";
import useLocalStorage from "./hooks";

const Wrapper = ({ children, ...props }) => {
    const { pageContext: { defaultLocale }, entity: { locale, Components } } = props;
    const [textSize, setTextSize] = useLocalStorage('text.size', '');
    const htmlAttributes = { class: textSize };

    const [player, setPlayer] = useState(null);
    const [fullscreenMode, setFullscreenMode] = useState(Components?.some(component => component.fullscreen === true));
    const entityRepository = new EntityRepository(useAllEntities());
    const moduleRepository = new ModuleRepository(useAllModules());

    return (
        <GlobalContext.Provider value={{ player, setPlayer, fullscreenMode, setFullscreenMode,
                                         entityRepository, moduleRepository }}>
            <Layout {...props}>
                <IDANativeBridge {...props}>
                    <Pwa {...props} />
                    <Seo title={`${props.entity?.title || props.entity?.identifier || 'Home'}`} lang={locale || defaultLocale} htmlAttributes={htmlAttributes}/>
                    {children}
                </IDANativeBridge>
            </Layout>
        </GlobalContext.Provider>
    )
}


export default Wrapper;
